// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__CXkpY","list":"PatternAutocomplete_list__SXV5v"};